import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react'
import { ContentSize, NavigationDrawerContextState } from './types'

const NavigationDrawerContext = createContext<NavigationDrawerContextState>(
  {} as NavigationDrawerContextState,
)

export const NavigationDrawer: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [activeItem, setActiveItem] = useState<string | undefined>(undefined)
  const [size, setSize] = useState<ContentSize>('sm')

  const resetDrawer = useCallback(() => {
    setActiveItem(undefined)
    setSize('sm')
  }, [])

  const context = useMemo<NavigationDrawerContextState>(
    () => ({
      activeItem,
      setActiveItem,
      size,
      setSize,
      resetDrawer,
    }),
    [activeItem, size],
  )

  return (
    <NavigationDrawerContext.Provider value={context}>
      {children}
    </NavigationDrawerContext.Provider>
  )
}

export const useNavigationDrawerContext = () =>
  useContext(NavigationDrawerContext)
